// theme/applyTheme.js
//
// Bridges theme/tokens.js (a plain JS object, framework-agnostic) into CSS
// custom properties on :root, so plain CSS files (index.css) and inline
// styles can read `var(--color-teal)` etc. without a CSS-in-JS library.
// tokens.js stays the single source of truth — edit values there, not here
// or in index.css.

import { tokens } from "./tokens.js";

function resolveFont(key) {
  return tokens.font[key] || key;
}

export function applyTheme() {
  const r = document.documentElement.style;

  Object.entries(tokens.color).forEach(([k, v]) => r.setProperty(`--color-${k}`, v));

  r.setProperty("--font-heading", tokens.font.heading);
  r.setProperty("--font-body", tokens.font.body);

  Object.entries(tokens.type).forEach(([variant, t]) => {
    r.setProperty(`--type-${variant}-family`, resolveFont(t.fontFamily));
    r.setProperty(`--type-${variant}-size`, t.fontSize);
    r.setProperty(`--type-${variant}-leading`, t.lineHeight);
    r.setProperty(`--type-${variant}-weight`, t.fontWeight);
    if (t.letterSpacing) r.setProperty(`--type-${variant}-tracking`, t.letterSpacing);
  });

  Object.entries(tokens.textOn.light).forEach(([k, v]) => r.setProperty(`--on-light-${k}`, v));
  Object.entries(tokens.textOn.dark).forEach(([k, v]) => r.setProperty(`--on-dark-${k}`, v));

  Object.entries(tokens.bg).forEach(([k, v]) => r.setProperty(`--bg-${k}`, v));

  Object.entries(tokens.radius).forEach(([k, v]) => r.setProperty(`--radius-${k}`, `${v}px`));
  Object.entries(tokens.shadow).forEach(([k, v]) => r.setProperty(`--shadow-${k}`, v));

  Object.entries(tokens.button.height).forEach(([k, v]) => r.setProperty(`--btn-h-${k}`, `${v}px`));
  Object.entries(tokens.button.paddingX).forEach(([k, v]) => r.setProperty(`--btn-px-${k}`, `${v}px`));
  Object.entries(tokens.button.fontSize).forEach(([k, v]) => r.setProperty(`--btn-fz-${k}`, v));
  r.setProperty("--btn-radius", `${tokens.button.radius}px`);

  Object.entries(tokens.input).forEach(([k, v]) => {
    if (typeof v === "object") Object.entries(v).forEach(([sk, sv]) => r.setProperty(`--input-${k}-${sk}`, typeof sv === "number" ? `${sv}px` : sv));
    else r.setProperty(`--input-${k}`, typeof v === "number" ? `${v}px` : v);
  });

  Object.entries(tokens.card.padding).forEach(([k, v]) => r.setProperty(`--card-pad-${k}`, `${v}px`));
  r.setProperty("--card-radius", `${tokens.card.radius}px`);
  ["elevated", "outlined", "flat"].forEach((variant) => {
    Object.entries(tokens.card[variant]).forEach(([k, v]) => r.setProperty(`--card-${variant}-${k}`, v));
  });

  ["primary", "dark", "light"].forEach((variant) => {
    Object.entries(tokens.banner[variant]).forEach(([k, v]) => r.setProperty(`--banner-${variant}-${k}`, v));
  });

  for (let i = 0; i <= 12; i++) r.setProperty(`--space-${i}`, tokens.space(i));
}
